<template>
  <div class='h100-40 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data'
              :allowPaging='true' :pageSettings='pageSettings' :currentPage='pageSettings.pageNo' :allowReordering='true' :allowResizing='true'>
      <e-columns>
        <e-column field='neId' minWidth='10' :headerText='$t("TS.neID")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='num' minWidth='10' :headerText='$t("TS.userNumber")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='onlineTime' minWidth='10' :headerText='$t("TS.onlineTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='onlineTimeFormat'></e-column>
        <!--<e-column field='statistic_time' minWidth='10' :headerText='$t("TS.statisticsTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>-->
      </e-columns>
    </ejs-grid>
    <!--<ejs-pager ref='pager' @click='getOnlineTimeData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>-->
    <CustomDialog ref='searchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch' :messages='dialog.messages.search'>
      <template v-slot:dialog-content>
        <QueryMonthDataDialog ref="query"></QueryMonthDataDialog>
      </template>
    </CustomDialog>
  </div>
</template>
<script>

import { Reorder, Resize, Page, CommandColumn, Edit } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../common/CustomDialog';
import QueryMonthDataDialog from '../QueryMonthDataDialog';
import Global from '../Global';

export default {
  name: 'OnlineTimeTable',
  components: {
    CustomDialog,
    QueryMonthDataDialog
  },
  data() {
    return {
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      selectionOptions: { type: 'Single' },
      olapUrl: Global.olapUrl,
      pageSettings: {
        // template: '<ejs-textbox></ejs-textbox>',
        pageSizes: [15,30,50],
        pageSize: 15
      },
      keywords: '', // 任务名称模糊查询关键字
      queryConditions: '',
      data: [],
      primaryDatas: [],
      shipColumns: [
        {
          field: 'ShippedDate',
          headerText: 'Shipped Date',
          format: 'yMd',
          textAlign: 'Right',
          width: 150,
          minWidth: 10
        },
        {
          field: 'ShipCountry',
          headerText: 'Ship Country',
          width: 150,
          minWidth: 10
        }
      ],
      dialog: {
        styles: {
          width: '60%',
          height: '80%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '40%',
          height: '80%',
          visible: false,
          model: true
        },
        element: {
          eleSearch: {
            target: this.$refs.callFailCountChart,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closeSearch, buttonModel: { content: this.$t('TS.ts_cancell') } },
              { click: this.queryConfirmFunc, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: this.$t('TS.ts_search'),
            isClose: true
          }
        },
        messages: {
          search: {
            title: this.$t('TS.gs_search')
          }
        }
      }
    };
  },
  provide: {
    grid: [Reorder, Resize, Page, CommandColumn, Edit]
  },
  methods: {
    onlineTimeFormat(grid, data) {
      if (data.onlineTime !== null && data.onlineTime !== '') {
        const time = parseInt(data.onlineTime);
        if (time < 60) {
          return `< 1 ${this.$t('TS.timeShowMin')}`;
        }
        const h = Math.floor(time / 3600);
        const m = Math.round((time - h*3600) / 60);
        if (h === 0) {
          return `${m} ${this.$t('TS.timeShowMin')}`;
        } else if (m === 0) {
          return `${h} ${this.$t('TS.timeShowHour')}`;
        }
        return `${h} ${this.$t('TS.timeShowHour')} ${m} ${this.$t('TS.timeShowMin')}`;
      } else {
        return '';
      }
    },
    searchPage() {
      this.$refs.searchPage.show();
      return null;
    },
    closeSearch() {
      this.$refs.searchPage.clear();
      this.$refs.searchPage.close();
    },
    searchNum() {
      const pager = this.$refs.grid.getPager();
      const instances = pager.ej2_instances;
      const pageSize = instances[0].pageSize;
      this.pageSettings = {
        pageSizes: [15,30,50],
        pageSize: pageSize,
        currentPage: 1
      }
      if (this.keywords === '') {
        this.data = this.primaryDatas;
      } else {
        const numDatas = this.primaryDatas.filter(numData => (numData.num.includes(this.keywords)));
        this.data = numDatas;
      }
    },
    queryConfirmFunc() {
      this.getOnlineTimeData();
    },
    getOnlineTimeData() {
      const This = this;
      let dateTime = "";
      This.queryConditions = This.$refs.query.getSearchCondition();
      // if (This.queryConditions.timeInterval == 2) {
      //   dateTime = This.formatDataStr(This.queryConditions.dayTime, 2)
      // } else {
      //   dateTime = This.formatDataStr(This.queryConditions.monthTime, 3)
      // }
      // This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      let numList = [];
      if (This.queryConditions.num != '' &&  This.queryConditions.num != null) {
        numList = This.queryConditions.num.trim().split(",");
      }
      const params = {
        dateTime: dateTime,
        interval: This.queryConditions.timeInterval,
        neId: This.queryConditions.neId,
        beginTime: This.queryConditions.beginTime,
        endTime: This.queryConditions.endTime,
        numList: numList
        // pageNo: parseInt(This.page.pageNo, 10),
        // pageSize: parseInt(This.page.pageSize, 10)
      };
      // 获取表格数据
      // const url = `/olap/ems/olap/onlineTime/getOnlineTimeData.html?dateTime=${dateTime}&interval=${This.queryConditions.timeInterval}&neId=${This.queryConditions.neId}`;
      This.$loading.showLoadding(this.$t('MML.loadingTip'));
      This.$axios.post(`${This.olapUrl}/lte/ems/olap/onlineTime/getOnlineTimeData`, params).then((response) => {
        if (response && response.status === 200) {
          This.closeSearch();
          This.$emit('refresh', null);
          const result = response.data
          // This.page.totalCount = result.total;
          This.data = result;
          This.primaryDatas = result;
        }
        This.$loading.hideLoadding();
      }).catch(err => {
        This.$loading.hideLoadding();
      });
    },
    formatDataStr(val, type) {
      const dateValue = new Date(val);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      if (type === 2) {
        let day = dateValue.getDate();
        if (day < 10) {
          day = `0${day}`;
        }
        return `${dateValue.getFullYear()}-${month}-${day}`;
      } else {
        return `${dateValue.getFullYear()}-${month}`;
      }

    }
  },
  mounted() {
    this.getTrackListData;

  }
};
</script>
